import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState } from 'react';
import { z } from 'zod';
import { Flex, Heading, HelpText, Link, Meter, Text, Tooltip } from '@applyboard/crystal-ui';
import { DashboardOutlineIcon } from '@applyboard/ui-icons';
import { useTranslation } from '@applyboard/ui-utils';
import { ApplicationActionName } from "../../../../types";
import { useApplicationAvailableActions, useApplicationConfiguration, useApplicationMainIntake } from "../../data";
import { ChangeIntakeModal } from "../ChangeIntakeModal";
import { RecommendedProgramsDialog } from "../RecommendedProgramsDialog";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var SegmentIntent = z.union([z.literal('positive'), z.literal('warning'), z.literal('negative'), z.literal('magic'), z.literal('primary'), z.literal('secondary')]);
export function SuccessScores() {
  var _mainIntake$seatAvail;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedAction = _useState2[0],
    setSelectedAction = _useState2[1];
  var _useTranslation = useTranslation('ApplicationStepper'),
    t = _useTranslation.t;
  var _useApplicationConfig = useApplicationConfiguration(),
    applicationSuccessScoreLevels = _useApplicationConfig.applicationConfiguration.applicationSuccessScoreLevels;
  var _useApplicationMainIn = useApplicationMainIntake(),
    mainIntake = _useApplicationMainIn.mainIntake,
    mainIntakeScoreLevel = _useApplicationMainIn.mainIntakeScoreLevel,
    isMainIntakeBelowCtaThreshold = _useApplicationMainIn.isMainIntakeBelowCtaThreshold;
  var _useApplicationAvaila = useApplicationAvailableActions(),
    canPerformApplicationAction = _useApplicationAvaila.canPerformApplicationAction;
  var mainIntakeScore = mainIntake === null || mainIntake === void 0 ? void 0 : (_mainIntake$seatAvail = mainIntake.seatAvailability) === null || _mainIntake$seatAvail === void 0 ? void 0 : _mainIntake$seatAvail.score;
  var meterSegments = applicationSuccessScoreLevels.map(function (level) {
    return {
      upperLimit: level.threshold,
      displayName: level.level,
      intent: SegmentIntent.safeParse(level.colorCode).data
    };
  });
  var canChangeIntake = canPerformApplicationAction(ApplicationActionName.CHANGE_INTAKE);
  var canSeeRecommendedPrograms = canPerformApplicationAction(ApplicationActionName.RECOMMENDED_PROGRAM);
  var showCtaActions = isMainIntakeBelowCtaThreshold && (canChangeIntake || canSeeRecommendedPrograms);
  if (!mainIntakeScoreLevel || mainIntakeScore === undefined) {
    return null;
  }
  return _jsxs(_Fragment, {
    children: [_jsxs(Flex, {
      direction: "column",
      gap: 4,
      children: [_jsxs(Flex, {
        gap: 4,
        align: "center",
        children: [_jsx(DashboardOutlineIcon, {}), _jsxs(Flex, {
          gap: 2,
          align: "center",
          children: [_jsx(Heading, {
            level: 2,
            variant: "titleS",
            children: t('successScores')
          }), _jsx(Tooltip, {
            label: t('successScoresTooltip'),
            children: _jsx(Tooltip.Icon, {})
          })]
        })]
      }), _jsx(Meter, {
        "aria-label": t('successScores'),
        segments: meterSegments,
        value: mainIntakeScore
      }), _jsx(HelpText, {
        showIcon: !!isMainIntakeBelowCtaThreshold,
        intent: mainIntakeScoreLevel.helpTextIntent,
        children: mainIntakeScoreLevel.helpText
      }), showCtaActions && _jsxs(Flex, {
        direction: "column",
        gap: 2,
        align: "start",
        children: [canChangeIntake && _jsx(Link, {
          as: "button",
          onClick: function onClick() {
            return setSelectedAction(ApplicationActionName.CHANGE_INTAKE);
          },
          children: _jsx(Text, {
            children: t('changeIntake')
          })
        }), canSeeRecommendedPrograms && _jsx(Link, {
          as: "button",
          onClick: function onClick() {
            return setSelectedAction(ApplicationActionName.RECOMMENDED_PROGRAM);
          },
          children: _jsx(Text, {
            children: t('seeRecommendedPrograms')
          })
        })]
      })]
    }), _jsx(ChangeIntakeModal, {
      hideDialogTrigger: true,
      isOpenViaProp: selectedAction === ApplicationActionName.CHANGE_INTAKE,
      origin: "Success score",
      onOpenChange: function onOpenChange() {
        return setSelectedAction(null);
      }
    }), _jsx(RecommendedProgramsDialog, {
      triggerSettings: {
        hide: true
      },
      isOpen: selectedAction === ApplicationActionName.RECOMMENDED_PROGRAM,
      onOpenChange: function onOpenChange() {
        return setSelectedAction(null);
      },
      origin: "Success score"
    })]
  });
}